export default "__VITE_ASSET__CEdwxXdO__"